<!--   -->

<div>
  <div class="col-sm-12 padding-right-0 padding-left-0">
    <app-common-skeleton *ngIf="loadAPIcall" [countforView]="5"
      [NameOftheScreen]="'candidateDetails'"></app-common-skeleton>
  </div>
  <div *ngIf="!loadAPIcall" class="col-sm-12 padding-right-0 padding-left-0">

    <div class="hpanel margin-bottom-5 gs-card" >
      <div class="panel-heading hbuilt gs-card-header">

        <label *ngIf="commonVariables?.localUser" class="control-label padding-top-0 gs-card-title">About
          Yourself</label>
        <label *ngIf="!commonVariables?.localUser" class="control-label padding-top-0 gs-card-title">About</label>
        <div class="panel-tools gs-card-tools">
          <div class="col-md-1" *ngIf="commonVariables?.localUser">
            <div class="btn-group">
              <div class="col-sm-2" style="margin-right: -15px;" title="Edit about yourself" (click)="aboutEdit()">
                <button id="aboutYourSelfEdit" class="gs-icon-btn"><span>
                    <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                  </span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-body gs-card-body" style="word-wrap: break-word;">

        <div *ngIf="hasValidAboutMe(infoData?.aboutMe)">
          <div [ngxSummernoteView]="infoData.aboutMe"></div>
        </div>

        <div *ngIf="!hasValidAboutMe(infoData?.aboutMe)" class="gs-card-empty-wrap">
          <div *ngIf="commonVariables?.localUser" class="gs-card-empty">
            Please write something of yourself
          </div>

          <div *ngIf="!commonVariables?.localUser" class="gs-card-empty">
            {{ infoData.firstName }} {{ infoData.lastName }} hadn’t added anything here
          </div>
        </div>
      </div>
    </div>


    <div class="hpanel margin-bottom-5 gs-card"
      *ngIf="(physicianFlag&&commonVariables?.localUser) || (!commonVariables?.localUser&&!isCollapsed&&physicianFlag)">
      <div class="panel-heading hbuilt gs-card-header">
        <label class="control-label padding-top-0 gs-card-title">Service Options</label>
        <div class="panel-tools gs-card-tools">

          <div class="row" style="display: flex;">
            <div style="margin-top: -14px; min-width: max-content; margin-right:25px; margin-top: -20px;">
              <div *ngIf="commonVariables?.localUser" class="custom-checkbox " [formGroup]="personalInfoForm">
                <label class="checkbox-label font-bold" style="text-align: center"> Not
                  Applicable
                  <input type="checkbox" formControlName="nonApplicable"
                    (click)="notApplicable($event,physicianTemplate)" [attr.aria-expanded]="!isCollapsed"
                    aria-controls="collapseBasic">
                  <span class="checkmark"></span>
                </label>
              </div>
              <div class="btn-group" style="padding:18px" *ngIf="commonVariables?.localUser&&!isCollapsed">
                <div title="Edit service options" (click)="physicianEdit(physicianTemplate)">
                  <button class="gs-icon-btn">
                    <span>
                      <ng-icon name="tablerPencil" class="gs-icon-action" style="margin-top: -6px;"></ng-icon>
                    </span></button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body gs-card-body" id="collapseBasic" [collapse]="isCollapsed" [isAnimated]="true" style="margin: 8px -10px 8px -10px;border-top: 2px solid;border-color: #eaeaea;
                                border-bottom: none;
                                border-right: none;
                                border-left: none;">
          <div class="row">
            <div class="col-sm-2">
              <label class="control-label card-title-font">Conditions</label>
            </div>
            <div class="col-sm-4" *ngIf="conditions!=undefined&&
                                                conditions!=null&&
                                                conditions!=''">
              <p class="card-subtitle-font font-bold">{{conditions}}</p>
            </div>
            <div class="col-sm-4" *ngIf="conditions==undefined||
                                                conditions==null||
                                                conditions==''">
              <p class="card-subtitle-font font-bold">None</p>
            </div>
            <div class="col-sm-2">
              <label class="control-label card-title-font">Insurance Accepted</label>
            </div>
            <div class="col-sm-4" *ngIf="insurance!=undefined&&insurance!=null&&insurance!=''">
              <div class="card-subtitle-font font-bold">{{insurance}}</div>
            </div>
            <div class="col-sm-4" *ngIf="insurance==undefined||insurance==null||insurance==''">
              <p class="card-subtitle-font font-bold">None</p>
            </div>

          </div>
          <div class="row">
            <div class="col-sm-2">
              <label class="control-label card-title-font">Accepting New Patients</label>
            </div>
            <div class="col-sm-4" *ngIf="patientAcceptance!=undefined&&patientAcceptance!=null&&patientAcceptance!=''">
              <p class="card-subtitle-font font-bold">{{patientAcceptance}}</p>
            </div>
            <div class="col-sm-4" *ngIf="patientAcceptance==undefined||patientAcceptance==null||patientAcceptance==''">
              <p class="card-subtitle-font font-bold">No</p>
            </div>
            <div class="col-sm-2">
              <label class="control-label card-title-font">Private Pay Accepted</label>
            </div>
            <div class="col-sm-4" *ngIf="privatePay!=undefined&&privatePay!=null&&privatePay!=''">
              <p class="card-subtitle-font font-bold">{{privatePay}}</p>
            </div>
            <div class="col-sm-4" *ngIf="privatePay==undefined||privatePay==null||privatePay==''">
              <p class="card-subtitle-font font-bold">No</p>
            </div>

          </div>
        </div>
        <!-- </div> -->
        <!-- </ng-container> -->
      </div>
    </div>

    <form [formGroup]="userPrivacyForm" class="app-form">
      <!-- *ngIf="(workPrivacy&&!commonVariables?.localUser )|| (commonVariables?.localUser && page === 'personalProfile')" -->
      <div class="hpanel margin-bottom-5 gs-card">

        <div class="panel-heading hbuilt gs-card-header">
          <label class="control-label padding-top-0 gs-card-title">Work Experience</label>
          <div class="panel-tools gs-card-tools" *ngIf="commonVariables?.localUser">
            <div class="row gs-privacy-pill" style="margin-right: 5px;">
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose private to hide this from everyone">Private
                    <input type="radio" name="workExperience" formControlName="workExperience"
                      id="workExperiencePrivacyRadio1" [value]="true" (change)="work(true)">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose public to show this to everyone">Public
                    <input type="radio" name="workExperience" formControlName="workExperience"
                      id="workExperiencePrivacyRadio2" (change)="work(false)" [value]="false">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>

              <!-- style=" padding-left: 3px;
                            margin-top: -2px;" -->
              <!-- btn-circle -->
              <div class="col-sm-2" title="Add work experience" (click)="experEdit(workTemplate, null, 'add')">
                <button class="gs-icon-btn" id="createWorkExperience">
                  <span>
                    <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
                  </span>
                </button>
                <!-- <span class="gs-icon-btn">
                  <ng-icon name="tablerPlus" class="btn btn-xs btn-default" style="padding:4px 5px; margin-top:2px"></ng-icon>
                </span> -->
              </div>



            </div>
          </div>
        </div>
        <div class="panel-body gs-card-body" style="word-wrap: break-word;">

          <div>
            <p *ngIf="workPrivacy&&!commonVariables?.localUser">Confidential</p>
            <p *ngIf="commonVariables?.localUser && infoData?.workExperience?.length == 0">You haven't provided your
              work experience details yet</p>

            <!-- visibleWorkExperience, not infoData.workExperience: a viewer left with
                 nothing to see - every row hidden by "Show this workplace in Profile" -
                 gets this copy instead of an empty card. -->
            <p *ngIf="!commonVariables?.localUser && !workPrivacy && visibleWorkExperience?.length == 0">
              {{infoData.firstName + " " + infoData.lastName}} hadn't
              provided their
              work
              experience details yet</p>
          </div>

          <div *ngIf="!workPrivacy&&!commonVariables?.localUser || commonVariables?.localUser">
            <!-- visibleWorkExperience is infoData.workExperience itself for the owner,
                 so `i` still indexes the real array for experEdit()/removeWorkExperience();
                 for other viewers it drops the current workplace when the owner
                 unchecked "Show this workplace in Profile". -->
            <div class=" row" *ngFor="let work of visibleWorkExperience; let i = index; let lastItem= last">
              
              <div class="col-sm-2" *ngIf="work.organisationName!=undefined&&work.organisationName!=null&&
                      work.organisationName!=''">
                <img *ngIf="work.businessLogo == null || work.businessLogo == undefined; else logoTemplate" class="img"
                  height="73px" width="73px" style="margin-left: -16px;" src="assets/images/gallery/company.png">
                <ng-template #logoTemplate>
                  <img class="business-logo" [src]="photoUrl+work.businessLogo">
                </ng-template>
              </div>
              <div class="col-sm-8" *ngIf="work.organisationName!=undefined&&work.organisationName!=null&&
                      work.organisationName!=''">
                <div class="letter-gaps project-label ellipsis">
                  {{work.organisationName}}
                </div>
                <div *ngIf="work.title!=undefined&&work.title!=null&&
                              work.title!=''" class="letter-gaps">
                  {{work.title}}

                </div>
                <div *ngIf="work.city!=undefined&&work.city!=null&&
                                          work.city!=''&&
                                          work.state!=undefined&&work.state!=null&&
                                          work.state!=''&&
                                          work.country!=undefined&&work.country!=null&&
                                          work.country!=''" class="letter-gaps" style="margin-bottom: -6px;">
                  <!-- {{", Zip - "}}{{work.zipcode}} -->
                  <!-- {{work.street}}{{", "}} -->
                  {{work.city}}{{", "}}{{work.state}}{{", "}}<span style="display: inline-block;"
                    *ngFor="let country of countryList">
                    <p *ngIf="country.countryCode == work.country">{{country.countryName}}</p>
                  </span>

                </div>
                <!-- currentIndex!=i&& -->
                <div class="letter-gaps" *ngIf="work.currentOrganization==false&&
                          work.startMonth!=undefined&&work.startMonth!=null&&work.startMonth!=''&&
                          work.startYear!=undefined&&work.startYear!=null&&work.startYear!=''&&
                          work.endMonth!=undefined&&work.endMonth!=null&&work.endMonth!=''&&
                          work.endYear!=undefined&&work.endYear!=null&&work.endYear!=''">

                  {{work.startMonth.substring(0, 3)}}{{", "}}{{work.startYear }}
                  {{" - "}}{{work.endMonth.substring(0, 3)}}{{", "}}{{work.endYear }}

                </div>
                <!-- currentIndex==i&& -->
                <div class="letter-gaps" *ngIf="work.currentOrganization==true&&
                          work.startMonth!=undefined&&work.startMonth!=null&&work.startMonth!=''&&
                          work.startYear!=undefined&&work.startYear!=null&&work.startYear!=''">

                  {{work.startMonth.substring(0, 3)}}{{", "}}{{work.startYear}}{{" - "}}
                  <span class="label label-info font-normal" style="font-size: 11px;">Present</span>

                </div>
                <hr *ngIf="!lastItem">
              </div>

              <div class="col-sm-1" *ngIf="commonVariables?.localUser">
                <div class="btn-group" style="margin-left: -13px;" title="Edit work experience"
                  (click)="experEdit(workTemplate, i, 'edit')">
                  <button class="gs-icon-btn" id="editWorkExperience"><span>
                      <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                    </span></button>
                </div>
              </div>

              <div class="col-sm-1" *ngIf="commonVariables?.localUser">
                <div class="btn-group" style="margin-left: -13px;" title="Remove work experience"
                  (click)="removeWorkExperience(i)">
                  <button class="gs-icon-btn"><span>
                      <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                    </span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hpanel margin-bottom-5 gs-card" >
        <div class="panel-heading hbuilt gs-card-header">
          <label class="control-label padding-top-0 gs-card-title">Education</label>
          <div class="panel-tools gs-card-tools">
            <div class="row gs-privacy-pill" style="margin-right: 5px;" *ngIf="commonVariables?.localUser">
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose private to hide this from everyone">Private
                    <input type="radio" name="educationDetail" formControlName="educationDetail"
                      (change)="edu(true)" id="educationDetailPrivacyRadio1" [value]="true">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose public to show this to everyone">Public
                    <input type="radio" name="educationDetail" formControlName="educationDetail"
                      (change)="edu(false)" id="educationDetailPrivacyRadio2" [value]="false">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-2" (click)="eduEdit(eduTemplate, null, 'add')" style=" padding-left: 3px;
                            margin-top: -2px;">

                <button title="Add education" class="gs-icon-btn" id="createEducation">
                  <span>
                    <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
                  </span>
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body gs-card-body" style="word-wrap: break-word;">
          <div>
            <p *ngIf="eduPrivacy&&!commonVariables?.localUser"> Confidential</p>
            <p *ngIf="commonVariables?.localUser && infoData?.educationDetail?.length == 0">You haven't added any
              education details yet</p>
            <p *ngIf="!commonVariables?.localUser && !eduPrivacy && infoData?.educationDetail?.length == 0">
              {{infoData.firstName + " " + infoData.lastName}} hadn't
              added
              any education details yet</p>

          </div>
          <div *ngIf="!eduPrivacy&&!commonVariables?.localUser || commonVariables?.localUser">
            <div *ngFor="let edu of infoData?.educationDetail; let i=index; let lastItem = last">

              <div *ngIf="edu.schoolName!=undefined&&edu.schoolName!=null&&edu.schoolName!=''">
                <div class="row" style="margin-bottom: 10px;">
                  <div class="col-sm-2">
                    <img class="img" style="margin-left: -13px;height: 73px;width: 73px;"
                      src="assets/images/gallery/education.png">
                  </div>
                  <div class="col-sm-8">
                    <div class="project-label letter-gaps">
                      {{edu.schoolName}}
                    </div>
                    <div class="letter-gaps" *ngIf="edu.degree!=undefined&&edu.degree!=null&&edu.degree!=''">
                      {{edu.degree}}
                    </div>


                    <div class="letter-gaps" *ngIf="edu.city!=undefined&&edu.city!=null&&edu.city!=''&&
                                                      edu.state!=undefined&&edu.state!=null&&edu.state!=''&&
                                                      edu.country!=undefined&&edu.country!=null&&edu.country!=''&&
                                                      edu.street!=undefined&&edu.street!=null&&edu.street!=''&&
                                                      edu.zipcode!=undefined&&edu.zipcode!=null&&edu.zipcode!=''"
                      style="margin-bottom: -6px;">
                      {{edu.street}}{{", "}} {{edu.city}}{{", "}}{{edu.state}}{{", "}}<span
                        style="display: inline-block;" *ngFor="let country of countryList">
                        <p *ngIf="country.countryCode == edu.country">{{country.countryName}}</p>
                      </span>
                    </div>
                    <!-- {{", Zip - "}}{{edu.zipcode}} -->
                    <div class="letter-gaps" *ngIf="edu.startMonth!=undefined&&edu.startMonth!=null&&edu.startMonth!=''&&
                              edu.startYear!=undefined&&edu.startYear!=null&&edu.startYear!=''&&
                              edu.endMonth!=undefined&&edu.endMonth!=null&&edu.endMonth!=''&&
                              edu.endYear!=undefined&&edu.endYear!=null&&edu.endYear!='' &&
                              edu.currentlyPursued!=true">
                      {{edu.startMonth.substring(0, 3)}}{{", "}}{{edu.startYear}}{{" - "}}
                      {{edu.endMonth.substring(0, 3)}}{{", "}}{{edu.endYear}}
                    </div>
                    <div class="letter-gaps" *ngIf=" edu.currentlyPursued==true">
                      {{edu.startMonth.substring(0, 3)}}{{", "}}{{edu.startYear}} {{" - "}}
                      <span class="label label-info font-normal" style="font-size: 11px;">Present</span>
                    </div>
                    <div class="rtz" *ngIf="commonVariables?.localUser">
                      <span *ngIf="commonVariables?.studentFlag==true && edu.showThisOnProfile==true">
                        <span>
                          <img style="max-height: 20px;" src="assets/icon/completed.PNG" alt="">
                        </span> This education is shown in
                        profile</span>
                    </div>
                  </div>
                  <div *ngIf="commonVariables?.localUser" class="col-sm-1" style="text-align-last: end;">
                    <div class="btn-group" style="margin-left: -13px;" title="Edit education"
                      (click)="eduEdit(eduTemplate, i, 'edit')">
                      <button class="gs-icon-btn" id="editEducation"><span>
                          <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                        </span></button>
                    </div>
                  </div>
                  <div class="col-sm-1" *ngIf="commonVariables?.localUser">
                    <!-- *ngIf="(commonVariables?.localUser&&infoData.educationDetail.length>1&&commonVariables?.studentFlag)||
                                      (commonVariables?.localUser&&!commonVariables?.studentFlag)" -->
                    <div class="btn-group" style="margin-left: -13px;" title="Remove education"
                      (click)="removeEducation(i , edu.eduId)">
                      <button class="gs-icon-btn"><span>
                          <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                        </span></button>
                    </div>
                  </div>
                </div>
                <hr *ngIf="!lastItem" style="margin-top: 0px;">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hpanel margin-bottom-5 gs-card" >
        <div class="panel-heading hbuilt gs-card-header">
          <label class="control-label padding-top-0 gs-card-title">Certifications</label>
          <div class="panel-tools gs-card-tools">
            <div class="row gs-privacy-pill" style="margin-right: 5px;" *ngIf="commonVariables?.localUser">
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose private to hide this from everyone">Private
                    <input type="radio" name="certification" formControlName="certification"
                      (change)="cert(true)" id="certificationPrivacyRadio1" [value]="true">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>

              </div>
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose public to show this to everyone">Public
                    <input type="radio" name="certification" formControlName="certification"
                      (change)="cert(false)" id="certificationPrivacyRadio2" [value]="false">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-2" style=" padding-left: 3px;
                            margin-top: -2px;" (click)="certEdit(certTemplate, null, 'add')">

                <button title="Add Certifications" class="gs-icon-btn" id="createCertification">
                  <span>
                    <ng-icon name="tablerPlus" class="gs-icon-action"></ng-icon>
                  </span>
                </button>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body gs-card-body" style="word-wrap: break-word;">
          <div>
            <p *ngIf="certPrivacy&&!commonVariables?.localUser"> Confidential</p>
            <p *ngIf="commonVariables?.localUser && infoData?.certification?.length == 0">You haven't added any
              certification details yet</p>
            <p *ngIf="!commonVariables?.localUser&&!certPrivacy && infoData?.certification?.length == 0">
              {{infoData.firstName + " " + infoData.lastName}} hadn't
              added
              any certification details yet</p>
          </div>
          <div *ngIf="!certPrivacy&&!commonVariables?.localUser || commonVariables?.localUser ">
            <div class="row" *ngFor="let cert of infoData?.certification; let i = index; let lastItem = last">

              <div *ngIf="cert.certificationName!=null && cert.certificationName!=undefined&&
                                  cert.certificationName!=''">

                <div class="col-sm-10">
                  <div class="letter-gaps">
                    {{cert.certificationName}}
                  </div>
                  <div class="letter-gaps" *ngIf="cert.certificateOrganization!=null && cert.certificateOrganization!=undefined&&
                                  cert.certificateOrganization!=''">
                    {{cert.certificateOrganization}}
                  </div>
                  <div class="letter-gaps" *ngIf="cert.startMonth!=null && cert.startMonth!=undefined&&cert.startMonth!=''&&
                                      cert.startYear!=null && cert.startYear!=undefined&&cert.startYear!=''&&
                                      cert.endMonth!=null && cert.endMonth!=undefined&&cert.endMonth!=''&&
                                      cert.endYear!=null && cert.endYear!=undefined&&cert.endYear!=''">
                    {{cert.startMonth.substring(0, 3) + ", "}}{{cert.startYear}}
                    {{" - "}}{{cert.endMonth.substring(0, 3) + ", "}}{{cert.endYear}}
                  </div>
                  <hr *ngIf="!lastItem">
                </div>
                <div class="col-sm-1" style="text-align-last: end;" *ngIf="commonVariables?.localUser">
                  <div class="btn-group" style="margin-left: -13px;" title="Edit certification"
                    (click)="certEdit(certTemplate, i, 'edit')">
                    <button class="gs-icon-btn" id="editCertification"><span>
                        <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                      </span></button>
                  </div>
                </div>
                <div class="col-sm-1" *ngIf="commonVariables?.localUser">
                  <div class="btn-group" style="margin-left: -13px;" title="Remove certification"
                    (click)="removeCertification(i)">
                    <button class="gs-icon-btn"><span>
                        <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                      </span></button>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>

      <div class="hpanel margin-bottom-5 gs-card" >
        <div class="panel-heading hbuilt gs-card-header">
          <label class="control-label padding-top-0 gs-card-title">Social
            Influence</label>
          <div class="panel-tools gs-card-tools">
            <div class="row gs-privacy-pill" style="margin-right: 5px;" *ngIf="commonVariables?.localUser">
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose private to hide this from everyone">Private
                    <input type="radio" name="socialPresence" formControlName="socialPresence"
                      (change)="social(true)" id="socialInfluencePrivacyRadio1" [value]="true">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-5 gs-privacy-option" style="padding-right: 11px;;">
                <div class="custom-radiobox">
                  <label class="containerR" title="Choose public to show this to everyone">Public
                    <input type="radio" name="socialPresence" formControlName="socialPresence"
                      (change)="social(false)" id="socialInfluencePrivacyRadio2" [value]="false">
                    <span class="checkmarkR radio_c"></span>
                  </label>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="btn-group" style="margin-left: -13px;" title="Edit social influence"
                  (click)="socialPresenceEdit(socialPresenceTemplate)">
                  <button class="gs-icon-btn" id="editSocialInfluence"><span>
                      <ng-icon name="tablerPencil" class="gs-icon-action"></ng-icon>
                    </span></button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="panel-body gs-card-body" style="word-wrap: break-word;">
          <div>
            <p *ngIf="socialPrivacy&&!commonVariables?.localUser"> Confidential</p>
          </div>
          <div *ngIf="(linkedin==null||linkedin==undefined||linkedin=='') && (twitter==null|| twitter==undefined||twitter=='')&&
                    (facebook==undefined|| facebook==null|| facebook=='') && (blogURL==undefined||blogURL==null||blogURL=='')&&
                    (alternamePageLink==null||alternamePageLink==null||alternamePageLink=='')">
            <p *ngIf="commonVariables?.localUser">You haven't added your social connections yet</p>

            <p *ngIf="!commonVariables?.localUser && !socialPrivacy">{{infoData.firstName + " " + infoData.lastName}}
              hadn't
              added any
              of their social connections yet</p>
          </div>
          <div *ngIf="!socialPrivacy&&!commonVariables?.localUser || commonVariables?.localUser ">
            <div class="row letter-gaps" *ngIf="linkedin">
              <div class="col-sm-1" style="padding-left: 14px;margin-right: -22px;">
                <ng-icon name="simpleLinkedin" style="color:  #0e76a8;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <a class="wbst" [attr.href]="linkedin.includes('https://') ? linkedin : 'https://'+linkedin"
                  target="_blank">{{linkedin }}
                </a>

              </div>
            </div>
            <div class="row letter-gaps" *ngIf="twitter">
              <div class="col-sm-1" style="padding-left: 14px;margin-right: -22px;">
                <ng-icon name="customX" style="color: #000000;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <!-- {{twitter}} -->
                <a class="wbst" [attr.href]="twitter.includes('https://') ? twitter : 'https://'+twitter"
                  target="_blank">{{twitter }}
                </a>
              </div>
            </div>
            <div class="row letter-gaps" *ngIf="facebook">
              <div class="col-sm-1" style="padding-left: 14px; margin-right: -22px;">
                <ng-icon name="simpleFacebook" style="color:  #3b5998;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <!-- {{facebook}} -->
                <a class="wbst" [attr.href]="facebook.includes('https://') ? facebook : 'https://'+facebook"
                  target="_blank">{{facebook }}
                </a>
              </div>
            </div>
            <div class="row letter-gaps" *ngIf="blogURL">
              <div class="col-sm-1" style="padding-left: 14px; margin-right: -22px;">
                <ng-icon name="tablerArticle" style="color: midnightblue;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <!-- {{blogURL}} -->
                <a class="wbst" [attr.href]=" blogURL" target="_blank">{{blogURL }}
                </a>
              </div>
            </div>
            <div class="row letter-gaps" *ngIf="alternamePageLink">
              <div class="col-sm-1" style="padding-left: 14px; margin-right: -22px;">
                <ng-icon name="tablerLayoutGrid" style="color: black;"></ng-icon>
              </div>
              <div class="col-sm-11">
                <!-- {{alternamePageLink}} -->
                <a class="wbst" [attr.href]="alternamePageLink" target="_blank">{{alternamePageLink }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="hpanel margin-bottom-5"
                *ngIf="(!commonVariables?.localUser && infoData.userPrivacy?.communities ) ||( commonVariables?.localUser && page === 'personalProfile'  )">
                <div class="panel-heading hbuilt gs-card-header">
                    <div class="panel-tools gs-card-tools">
                        <div class="row" style="margin-right: 42px;" *ngIf="commonVariables?.localUser">
                            <div class="col-sm-6">
                                <div class="custom-radiobox">
                                    <label class="containerR" title="Choose private to hide this from everyone">Private
                                        <input type="radio" name="communities" formControlName="communities"
                                            (change)="community($event.target.value, 'false')"
                                            id="communitiesPrivacyRadio1" [value]="false">
                                        <span class="checkmarkR radio_c"></span>
                                    </label>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="custom-radiobox">
                                    <label class="containerR" title="Choose public to show this to everyone">Public
                                        <input type="radio" name="communities" formControlName="communities"
                                            (change)="community($event.target.value, 'true')"
                                            id="communitiesPrivacyRadio2" [value]="true">
                                        <span class="checkmarkR radio_c"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <label class="control-label padding-top-0 gs-card-title">Communities</label>
                </div>
                <div class="panel-body gs-card-body" style="word-wrap: break-word;"
                    *ngIf="infoData.userPrivacy&&infoData.userPrivacy?.communities&& !commonVariables?.localUser">

                    <div *ngIf="commonVariables?.localUser&&infoData.communityList.length==0"> You have no communities
                        to
                        show
                        yet
                    </div>
                    <div *ngIf="!commonVariables?.localUser&&infoData.communityList.length==0">
                        {{infoData.firstName + " " + infoData.lastName}} hadn't created any communities yet
                    </div>

                    <div *ngIf="infoData.communityList!=null" class="custom-panel" [collapse]="mycommunities"
                        [isAnimated]="true">
                        <ul style="list-style-type: none; padding-left: 0px">

                            <li style="line-height: 20px"
                                *ngFor="let community of infoData.communityList |slice : startPageCom:paginationLimitCom"
                                (click)="setCommunityId(community)">
                                <a>
                                    {{community.communityName | truncate : 30}}
                                </a>
                            </li>
                            <li style="line-height: 20px"
                                *ngIf="infoData.communityList && infoData.communityList.length>5">
                                <p class="showMorePointer" *ngIf="paginationLimitCom < infoData.communityList.length"
                                    (click)="showMoreComm()">Show more</p>
                            </li>
                            <li style="line-height: 20px" *ngIf="showLessCommunity">
                                <p class="showMorePointer" *ngIf="paginationLimitCom" (click)="showLessComm()">Show Less
                                </p>
                            </li>

                        </ul>
                    </div>

                </div>


                <div class="panel-body gs-card-body" style="word-wrap: break-word;" *ngIf="commonVariables?.localUser">
                    <div *ngIf="commonVariables?.localUser&&infoData.communityList==null">You have no communities to
                        show
                        yet
                    </div>
                    <div *ngIf="!commonVariables?.localUser&&infoData.communityList==null">
                        {{infoData.firstName + " " + infoData.lastName}} hadn't created any communities yet
                    </div>
                    <div *ngIf="commonVariables?.localUser&&infoData.communityList!=null" class="custom-panel"
                        [collapse]="mycommunities" [isAnimated]="true">
                        <ul style="list-style-type: none; padding-left: 0px; ">

                            <li style="line-height: 20px"
                                *ngFor="let community of infoData.communityList |slice : startPageCom:paginationLimitCom"
                                (click)="setCommunityId(community)">
                                <a>
                                    <ng-icon name="tablerUser" *ngIf="community.entityType=='USER'"></ng-icon>
                                    <ng-icon name="tablerBriefcase" *ngIf="community.entityType=='BUSINESS'"></ng-icon>
                                    {{community.communityName | truncate : 30}}
                                </a>
                            </li>
                            <li style="line-height: 20px;"
                                *ngIf="infoData.communityList && infoData.communityList.length>5">
                                <p class="showMorePointer" style=" margin-left: 0px"
                                    *ngIf="paginationLimitCom < infoData.communityList.length" (click)="showMoreComm()">
                                    Show more...</p>
                            </li>
                            <li style="line-height: 20px" *ngIf="showLessCommunity">
                                <p class="showMorePointer" style=" margin-left: 0px" *ngIf="paginationLimitCom"
                                    (click)="showLessComm()">Show Less</p>
                            </li>
                        </ul>
                    </div>

                    <div *ngIf="!commonVariables?.localUser&&infoData.communityList!=null" class="custom-panel"
                        [collapse]="mycommunities" [isAnimated]="true">
                        <ul style="list-style-type: none; padding-left: 0px">

                            <li style="line-height: 20px"
                                *ngFor="let community of infoData.communityList |slice : startPageCom:paginationLimitCom"
                                (click)="setCommunityId(community)">
                                <a *ngIf="communityPrivacy&&community.communityType==false">
                                    <ng-icon name="tablerUser" *ngIf="community.entityType=='USER'"></ng-icon>
                                    <ng-icon name="tablerBriefcase" *ngIf="community.entityType=='BUSINESS'"></ng-icon>
                                    {{community.communityName | truncate : 30}}
                                </a>
                                <a *ngIf="!communityPrivacy&&community.communityType==true">
                                    <ng-icon name="tablerUser" *ngIf="community.entityType=='USER'"></ng-icon>
                                    <ng-icon name="tablerBriefcase" *ngIf="community.entityType=='BUSINESS'"></ng-icon>
                                    {{community.communityName | truncate : 30}}
                                </a>
                            </li>
                            <li style="line-height: 20px"
                                *ngIf="infoData.communityList && infoData.communityList.length>5">
                                <p class="showMorePointer" *ngIf="paginationLimitCom < infoData.communityList.length"
                                    (click)="showMoreComm()">Show more</p>
                            </li>
                            <li style="line-height: 20px" *ngIf="showLessCommunity">
                                <p class="showMorePointer" *ngIf="paginationLimitCom" (click)="showLessComm()">Show Less
                                </p>
                            </li>

                        </ul>
                    </div>
                </div>
            </div> -->
    </form>
  </div>
</div>



<ng-template #infoTemplate>

  <div class="common-header-flex">
    <div>Personal Details</div>
    <button>
      <span class="common-close" (click)="decline()">&times;</span>
    </button>
  </div>

  <div class="panel-body" style="padding-bottom: 0px !important;">
    <div>
      <form [formGroup]="personalInfoForm">
        <div class="container-fluid app-form form-horizontal">
          <div class="row">
            <div class="form-group">
              <div class="col-sm-3" style="padding-left: 41px;">
                <!-- *ngIf="photoId != undefined || photoId != null" -->
                <img alt="logo" class="avatar" [src]="img.src" onerror="this.src='assets/images/userAvatar.png';">
              </div>
              <div class="col-sm-8">
                <label for="userType" class="control-label required-field font-light">I am</label>

                <select class="form-control input-sm" formControlName="userType" id="userType1"
                  (change)="onChangeIam($event.target.value)" open>
                  <option value="null" *ngIf="personalInfoForm.value.userType==null" selected>
                    Choose your user type</option>
                  <option value="HEALTHCARE">Medical/ Healthcare professional </option>
                  <option value="adminPersonnel">Administrative Healthcare personnel</option>
                  <option title="Recruiter can create jobs on the platform to attract consultants" value="RECRUITER">
                    Recruiter </option>
                  <option title="Bench Recruiter can create consultants on the platform to attract jobs"
                    value="BENCH_RECRUITER">Bench Recruiter </option>
                  <option title="Job Seeker can look up for jobs." value="JOB_SEEKER">Job Seeker </option>
                  <!-- <option value="medicPracticeBusiness">Medical/Healthcare (Practice or Business)</option>
                                  <option value="institution">Educational Institution (Medical, Nursing, Healthcare) </option>
                                  <option value="nonProfit">Non-Profit Organization (Health/Wellness/Medical) </option> -->
                  <option value="Other">Other</option>
                </select>
                <div *ngIf="p.userType.invalid && (p.userType.dirty || p.userType.touched)" class="error-msg">
                  <div *ngIf="p.userType.errors.required"> This field is required</div>
                </div>
                <div *ngIf="commonVariables?.previousFlag" class="error-msg">
                  <div>Change your user type here</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <label class="col-sm-3 control-label required-field font-light">First Name</label>
              <div class="col-sm-8">
                <input type="text" class="form-control input-sm" placeholder="First Name" formControlName="firstName">
                <div *ngIf="p.firstName.invalid && (p.firstName.dirty || p.firstName.touched)" class="error-msg">
                  <div *ngIf="p.firstName.errors.required">First Name is required</div>
                  <div *ngIf="p.firstName.errors.pattern" class="text-danger">First Name must
                    contain alphabets only</div>
                  <div *ngIf="p.firstName.errors.cannotContainSpace" class="text-danger">
                    First Name cannot contain space</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <label class="col-sm-3 control-label required-field font-light">Last Name</label>
              <div class="col-sm-8">
                <input type="text" class="form-control input-sm" placeholder="Last Name" formControlName="lastName">
                <div *ngIf="p.lastName.invalid && (p.lastName.dirty || p.lastName.touched)" class="error-msg">
                  <div *ngIf="p.lastName.errors.required">Last Name is required</div>
                  <div *ngIf="p.lastName.errors.pattern" class="text-danger">Last Name must
                    contain alphabets only</div>
                  <div *ngIf="p.lastName.errors.cannotContainSpace" class="text-danger">Last
                    Name cannot contain space</div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="form-group">
              <label style="text-align: right;" for="photo" class="col-sm-3 control-label font-light">Photo</label>
              <div class="col-sm-8">
                <!-- <button class="btn  btn-primary" (click)="uploadPhoto()">Upload</button> -->
                <input type="file" accept=".jpg, .jpeg, .png" class="form-control  "
                  (change)="fileChangeEvent($event, templateNested)" id="profileimage" #myFileInput
                  (click)="myFileInput.value=null" />

                <ng-template #templateNested>

                  <div class="modal-content">

                    <div class="common-header-flex">
                      <div>Profile Photo</div>
                      <button><span class="common-close" (click)="closeImage()"
                          aria-hidden="true">&times;</span></button>
                    </div>

                    <div class="modal-body">
                      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                        [aspectRatio]="3 / 4" format="png,jpeg" (imageCropped)="imageCropped($event)"
                        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()">

                      </image-cropper>
                    </div>
                    <div class="modal-footer" style="border-radius: 5px;">
                      <div style="float: right;">
                        <button class="btn btn-default" (click)="closeImage()">Cancel</button>
                        <button class="btn primary-btn" (click)="imageLoaded()">Apply</button>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="form-group">
              <label for="phoneNo" class="col-sm-3 control-label font-light">Phone</label>
              <div class="col-sm-8">
                <input type="text" maxlength="15" class="form-control input-sm" placeholder="Phone"
                  formControlName="phoneNo">
                <div class="error-msg" *ngIf="p.phoneNo.invalid">
                  <div *ngIf="p.phoneNo.errors.maxlength">Phone numbers cannot exceed 15 digits
                  </div>
                  <div *ngIf="p.phoneNo.errors">Please enter only numerals (0-9)</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <label for="username" class="col-sm-3 control-label required-field font-light">Primary
                Email ID</label>
              <div class="col-sm-8">
                <input type="email" class="form-control input-sm" disabled placeholder="Primary Email ID"
                  formControlName="email">
                <div *ngIf="p.email.invalid && (p.email.dirty || p.email.touched)" class="error-msg">
                  <div *ngIf="p.email.errors.required">Primary Email ID is required</div>
                  <div *ngIf="p.email.errors.email"> Please enter a valid Email ID</div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <label for="secondaryEmail" class="col-sm-3 control-label font-light">Secondary Email
                ID</label>
              <div class="col-sm-8">
                <input type="email" class="form-control input-sm" placeholder="Secondary Email ID" trim="blur"
                  formControlName="secondaryEmail" (input)="emailidcehck($event.target.value)">
                <div *ngIf="p.secondaryEmail.invalid" class="error-msg">
                  <div *ngIf="p.secondaryEmail.errors.email">Please enter a valid Email ID</div>
                  <div *ngIf="p.secondaryEmail.errors.mustMatch">Secondary Email cannot be the
                    same as Primary Email</div>
                </div>
                <!-- <div class="error-msg" *ngIf="p.secondaryEmail.invalid && (p.secondaryEmail.dirty || p.secondaryEmail.touched)">
                                    <div *ngIf="p.secondaryEmail.errors.mustMatch"> Alternate Email cannot be the same as Primary Email</div>
                                  </div> -->
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group">
              <label class="control-label col-sm-3 required-field font-light">Location</label>
              <div class="col-sm-8">
                <div class="row form-group">
                  <div class="col-sm-6">
                    <select class="form-control input-sm" formControlName="country"
                      (change)="onChangeCountry($event.target.value, 'user', 'user')">
                      <option value="null" selected disabled>Country</option>
                      <option *ngFor="let country of countryList" [value]="country.countryCode">
                        {{country.countryName}}</option>

                    </select>
                    <div *ngIf="p.country.invalid && (p.country.dirty || p.country.touched)" class="error-msg">
                      <div *ngIf="p.country.errors.required"> Country is required</div>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                    <input type="text" maxlength="12" class="form-control input-sm" placeholder="Zipcode"
                      (keyup)="onKeyZip($event,'user', 'user')" formControlName="zipcode">
                    <div *ngIf="personalInfoForm.value.country=='US'&&( p.zipcode.invalid ||
                                     p.zipcode.invalid && (p.zipcode.dirty ||
                                      p.zipcode.touched))" class="error-msg">
                      <div *ngIf="p.zipcode.errors.required"> Zipcode is required</div>
                      <div *ngIf="p.zipcode.errors.minword">
                        {{FORMERROR.ZIPCODE_MIN}}
                      </div>
                      <div class="w-wrap" *ngIf="p.zipcode.errors.maxword">
                        {{FORMERROR.ZIPCODE_MAX}}
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='IN'">
                    <select class="form-control input-sm" formControlName="state" type="text">
                      <option value="null" selected disabled>State</option>
                      <option *ngFor="let state of stateListIN" [value]="state.stateName">
                        {{state.stateName}}</option>
                    </select>
                    <div *ngIf="personalInfoForm.value.country=='IN'&&( p.state.invalid ||
                                            p.state.invalid && (p.state.dirty ||
                                             p.state.touched))" class="error-msg">
                      <div *ngIf="p.state.errors.required"> State is required</div>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='CA'">
                    <select class="form-control input-sm" formControlName="state" type="text">
                      <option value="null" selected disabled>State</option>
                      <option *ngFor="let state of stateListCA" [value]="state.stateName">
                        {{state.stateName}}</option>
                    </select>
                    <div *ngIf="personalInfoForm.value.country=='CA'&&( p.state.invalid ||
                                        p.state.invalid && (p.state.dirty ||
                                         p.state.touched))" class="error-msg">
                      <div *ngIf="p.state.errors.required"> State is required</div>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='AU'">
                    <select class="form-control input-sm" formControlName="state" type="text">
                      <option value="null" selected disabled>State</option>
                      <option *ngFor="let state of stateListAU" [value]="state.stateName">
                        {{state.stateName}}</option>
                    </select>
                    <div *ngIf="personalInfoForm.value.country=='AU'&&( p.state.invalid ||
                                    p.state.invalid && (p.state.dirty ||
                                     p.state.touched))" class="error-msg">
                      <div *ngIf="p.state.errors.required"> State is required</div>
                    </div>
                  </div>
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='AU'&&
                                                              personalInfoForm.value.country!='CA'&&
                                                              personalInfoForm.value.country!='IN'&&
                                                              personalInfoForm.value.country!='US'">
                    <input formControlName="state" class="form-control input-sm" placeholder="State">
                    <div *ngIf="personalInfoForm.value.country!='AU'&&
                                              personalInfoForm.value.country!='CA'&&
                                              personalInfoForm.value.country!='IN'&&
                                              personalInfoForm.value.country!='US'&&( p.state.invalid ||
                                              p.state.invalid && (p.state.dirty ||
                                              p.state.touched))" class="error-msg">
                      <div *ngIf="p.state.errors.required"> State is required</div>
                      <div *ngIf="p.state.errors.maxword"> {{FORMERROR.STATE_MAX}}</div>
                    </div>
                  </div>
                </div>


                <div class="row">
                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                    <input type="text" disabled placeholder="City" formControlName="city" class="form-control input-sm">
                    <div *ngIf=" p.city.invalid || p.city.invalid && (p.city.dirty || p.city.touched)"
                      class="error-msg">
                      <div *ngIf="p.city.errors.required"> City is required</div>
                    </div>
                  </div>

                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='US'">
                    <input type="text" placeholder="City" formControlName="city" class="form-control input-sm">
                    <div *ngIf=" p.city.invalid || p.city.invalid && (p.city.dirty || p.city.touched)"
                      class="error-msg">
                      <div *ngIf="p.city.errors.required"> City is required</div>
                    </div>
                  </div>

                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country=='US'">
                    <input disabled formControlName="state" class="form-control input-sm" placeholder="State">
                    <div *ngIf="personalInfoForm.value.country=='US'&&( p.state.invalid ||
                                                p.state.invalid && (p.state.dirty ||
                                                p.state.touched))" class="error-msg">
                      <div *ngIf="p.state.errors.required"> State is required</div>
                      <div *ngIf="p.state.errors.maxword"> {{FORMERROR.STATE_MAX}}</div>
                    </div>
                  </div>

                  <div class="col-sm-6" *ngIf="personalInfoForm.value.country!='US'">
                    <input type="text" maxlength="12" class="form-control input-sm" placeholder="Zipcode"
                      formControlName="zipcode">
                    <div *ngIf="personalInfoForm.value.country!='US'&&( p.zipcode.invalid ||
                                         p.zipcode.invalid && (p.zipcode.dirty ||
                                          p.zipcode.touched))" class="error-msg">
                      <div *ngIf="p.zipcode.errors.required"> Zipcode is required</div>
                      <div *ngIf="p.zipcode.errors.minword">
                        {{FORMERROR.ZIPCODE_MIN}}
                      </div>
                      <div *ngIf="p.zipcode.errors.maxword">
                        {{FORMERROR.ZIPCODE_MAX}}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="row">
    <div class="text-right" style="padding-right: 46px;padding-top: 7px;padding-bottom:7px">
      <button class="btn btn-default " (click)="decline()">
        Cancel
      </button>
      <button *ngIf="!weird" class="btn primary-btn " type="button" (click)="infoSave()">
        Submit
      </button>
      <button class="btn primary-btn " type="button" *ngIf="weird"
        (click)="onChangePhysician1( physicianPrompTemplate, studentPrompTemplate)">
        Submit
      </button>
    </div>
  </div>
</ng-template>

<!-- <ng-template #aboutTemplate>
    <div class="row">
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span style="font-size: 26px;position: relative; top: 1rem; right: 3rem;" aria-hidden="true">&times;</span>
        </button>
        <label class="control-label padding-top-0 margin-bottom-5 " style="margin-left: 25px !important; margin-top: 14px; ">About
            Yourself</label>
    </div>
    <hr style="margin: 10px 0px 0px 0px;">
    <div class="modal-body" style="padding-bottom: 0px !important;">
        <form [formGroup]="aboutMeForm" class="app-form ">
            <div class="row">
                <div class="form-group">
                    <div class="col-sm-12">
                        <div formControlName="aboutMe" id="aboutMe" [ngxSummernote]="config"></div>
                        <label><small>Maximum characters allowed is 1000</small></label>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="row">
        <div class="text-right" style="padding-right: 46px;padding-top: 7px;padding-bottom:7px">
            <button class="btn btn-default" (click)="decline1()">
                Cancel
            </button>
            <button class="btn primary-btn  " id="enterbtn" style="margin-left:2%;" type="button"
                (click)="aboutSave()">
                Submit
            </button>
        </div>
    </div>
</ng-template> -->


<div bsModal #lgModal class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-sizes-name1">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">

      <div class="common-header-flex">
        <div>About Yourself</div>
        <button>
          <span (click)="closeModal()" class="common-close">&times;</span>
        </button>
      </div>

      <div class="panel-body">
        <form [formGroup]="aboutMeForm" class="app-form ">
          <div class="row">
            <div class="form-group">
              <div class="col-sm-12 R-summary">
                <div formControlName="aboutMe" #summernotes id="aboutMe" [ngxSummernote]="config2"></div>
                <div  class="red fl" *ngIf="amsubmit&&!aboutMeForm.controls.aboutMe.errors?.minchar"> About Yourself is required</div>
                <div *ngIf="
                                aboutMeForm.controls.aboutMe.invalid &&  (aboutMeForm.controls.aboutMe.dirty ||
                                aboutMeForm.controls.aboutMe.touched)" class="red fl">

                  <div *ngIf="aboutMeForm.controls.aboutMe.errors.maxchar">
                    {{FORMERROR.ABOUT_YOURSELF_MAX}}
                  </div>
                  <div class="red fl" *ngIf="aboutMeForm.controls.aboutMe.errors?.minchar">
                    {{FORMERROR.ABOUT_YOUR_MIN}}
                  </div>
                </div>
                <div class="text-right" *ngIf="!aboutMeForm.controls.aboutMe.errors?.maxchar">
                  <label>
                    <small>
                      <span>{{remainingCharacters}}</span>
                      Characters remaining
                    </small>
                  </label>
                </div>
              </div>
              <div class="col-sm-6">
              </div>
            </div>
          </div>
        </form>

      </div>


      <div class="custom-panel-footer">
        <div class="panel-footer">
          <div class="footer-flex">
            <button class="btn btn-default" (click)="decline1()">
              Cancel
            </button>
            <button   class="btn primary-btn  " id="enterbtn"
              style="margin-left:2%;" type="button" (click)="aboutSave()">
              Submit
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<ng-template #physicianTemplate>
  <div class="hpanel ">
    <div class="panel-heading">
      <div class="row panel-tools">
        <div style="margin-top: -5px;">
          <button type="button" class="close pull-left" aria-label="Close" (click)="modalRef.hide()">
            <span style="padding-right: 22px;font-weight:400;font-size: 27px;" aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
      <label class="control-label padding-top-0 margin-bottom-5 margin-top-5 f-size "
        style="margin-left: 8px !important">Service Options</label>
      <!-- <h4 class="control-label padding-top-0 margin-bottom-5 margin-top-5 f-size"> -->
      <!-- Service Options -->
      <!-- </h4> -->
    </div>


    <form [formGroup]="physicianForm" class="app-form">
      <div class="panel-body" style="padding-bottom: 0px !important;">
        <div class="form-group row">
          <label for="conditions" class="col-sm-3 col-form-label text-right font-light">Conditions</label>
          <div class="col-sm-8">
            <div >
              <ng-select [items]="conditionList" [multiple]="true" bindLabel="name" [hideSelected]="false"
                formControlName="conditions" dropdownPosition="bottom" placeholder="Conditions Treated"
                [(ngModel)]="conditionSelectedItems">

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>

            </div>

            <div *ngIf="physicianFlags" class="invalid-feedback">
              <div class="text-dander" style="padding-left: 237px;" *ngIf=" conditionSelectedItems.length==0">
                Conditions is required</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="insurance" class="col-sm-3 control-label text-right font-light ">Insurance
            Accepted</label>
          <div class="col-sm-8">
            <div >
              <ng-select [items]="insuranceList" [multiple]="true" [hideSelected]="false" dropdownPosition="bottom"
                formControlName="insurance" bindLabel="name" placeholder="Insurance Accepted"
                [(ngModel)]="insuranceSelectedItems">

                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <div class="ng-select-checkbox-label">
                    <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                    <span class="ng-select-checkbox-text">{{item}}</span>
                  </div>
                </ng-template>
              </ng-select>

            </div>
            <div *ngIf="physicianFlags" class="invalid-feedback">
              <div class="text-dander" style="padding-left: 241px;" *ngIf=" insuranceSelectedItems.length==0">
                Insurance is required</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="patientAcceptance" class="col-sm-3 control-label text-right font-light">Accepting New
            Patients</label>
          <div class="col-sm-9">

            <div class="row">
              <div class="col-sm-2" style="  padding-top: 4px; padding-right: 0px; ">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> Yes
                    <input type="radio" value="Yes" formControlName="patientAcceptance" name="patientAcceptance">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-2" style="  padding-top: 4px; padding-left: 12px">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> No
                    <input type="radio" value="No" formControlName="patientAcceptance" name="patientAcceptance">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label for="privatePay" class="col-sm-3 control-label text-right font-light">Private Pay
            Accepted</label>
          <div class="col-sm-9">
            <div class="row">
              <div class="col-sm-2" style="  padding-top: 4px;padding-right: 0px;">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> Yes
                    <input type="radio" value="Yes" formControlName="privatePay" name="privatePay">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="col-sm-2" style="  padding-top: 4px; padding-left: 12px">
                <div class="custom-checkbox" style="margin-top: 5px;">
                  <label class="checkbox-label font-normal" style="text-align: center;"> No
                    <input type="radio" value="No" formControlName="privatePay" name="privatePay">
                    <span title="Check Working Days" class="checkmark"></span>
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="text-right" style="padding-right: 46px;padding-top: 7px;padding-bottom:7px">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " style="margin-left:2%;" type="button" (click)="physicianSave()">
          Submit
        </button>

      </div>
    </form>
  </div>
</ng-template>

<ng-template #workTemplate>
  <div class=" " *ngIf="!commonVariables.emailDomainValidation">
    <app-workexperience-modal [header]="'Work Experience'" [content]="'PROFILE'" [supportModal]="supportModal"
      (profileListener)="editedExperience($event)" [workExperienceDetails]="PassWorkExperienceDetails"
      [ButtonName]="button" [availableWorkExperience]="availableWorkExp"></app-workexperience-modal>
  </div>

  <div class="hpanel" *ngIf="commonVariables.emailDomainValidation">
    <div class="panel-heading">
      <div class="row panel-tools" style="padding-right: 20px;">
        <button type="button" class="close" aria-label="Close" (click)="closeValidator()">
          <span style="font-size: 26px;font-weight:400;color: #fff;" aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="padding-top-0 margin-bottom-5 margin-top-5 f-size " style="margin-left: 8px !important;color: #fff;">
        Authenticate Business Email </div>
    </div>
    <div class="panel-body">
      <form [formGroup]="domainForm" action="">
        <div class="app-form">
          <div class="form-group row">
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that none of your emails are of a business domain. You have to provide business email as your primary source of contact for creating a job. Please, provide a business email below to proceed.
              </div>
            </div> -->
            <div class="row alrt-dngr">
              <!-- <div class="col-sm-12 domain-msg">

              </div> -->
              <div class="alert alert-danger addd-dngr" role="alert">
                Please, note that after you authenticate your new business email address, your previous login
                credentials will be changed for the new business email.

                <!-- After authenticating the business email it will become your primary email address, and you will be using it for the login credentials. -->
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that your secondary email address is of a business domain. You have to consider changing it to your primary by clicking the Swap Email button below to be able to create jobs.
              </div>
            </div> -->
            <!-- <div class="row">
              <div class="col-sm-12 domain-msg">
                It seems that you have not provided a secondary email address. It will be helpful to link you back when you change your work place to authenticate your future business email domains.
              </div>
            </div> -->
            <!-- <div class="col-sm-6" style="padding-bottom: 7px;">
              <label for="priEmail" class="control-label font-bold">New business email</label>
              <div>{{primaryEmail}}</div>
            </div> -->

            <div class="col-sm-12" style="display: flex; padding: 10px 18px; align-items: center;column-gap: 9px;">
              <div>
                <label>Previous Business Email:</label>
              </div>
              <div>{{previousEmailAddress}}</div>
            </div>
            <div class="col-sm-6"></div>


            <div class="col-sm-12" *ngIf="!otpEmailSent" style="padding-bottom: 7px;">
              <label for="swapEmail" class="control-label required-field font-bold">New Business Email
                Address</label>
              <input class="form-control input-sm" formControlName="swapEmail" #mytext type="text"
                (input)="checkMailExists(mytext.value)">
              <div *ngIf="
                  (domainValidatorSubmit && domainControl.swapEmail.invalid) ||
                  (domainControl.swapEmail.invalid &&
                    (domainControl.swapEmail.dirty ||
                      domainControl.swapEmail.touched))
                " class="error-msg">
                <div *ngIf="domainControl.swapEmail.errors.required">
                  New Business Email is required
                </div>
                <div *ngIf="domainControl.swapEmail.errors.genericDomain">
                  Please, enter a business email domain
                </div>
                <div *ngIf="domainControl.swapEmail.errors.emailExistsAlready">
                  That email is taken already. Please, enter a different one.
                </div>
                <div *ngIf="domainControl.swapEmail.errors.email">
                  Please, enter a valid email address.
                </div>
              </div>
            </div>
            <div class="col-sm-12" style="display:flex; column-gap: 13px;
            align-items: center;" *ngIf="otpEmailSent">
              <label for="">New Business Email:</label>
              <!-- <span (click)="edit()" class="edit-email">(edit)</span> -->
              {{domainForm.value.swapEmail}}
            </div>

            <div class="row alrt-dngr">
              <div *ngIf="otpEmailSent" class="alert alert-info addd-dngr" role="alert">
                An authentication code has been sent to your new business email. Please, enter it below. The code is
                valid only for 10 minutes.
              </div>
            </div>

            <div class="col-sm-12" *ngIf="otpEmailSent">
              <label for="domainValidationOtp" class="control-label required-field font-bold">Enter OTP</label>
              <input class="form-control input-sm" formControlName="domainValidationOtp" type="text" trim="blur">
              <div *ngIf="
                    (domainValidatorSubmit && domainControl.domainValidationOtp.invalid) ||
                    (domainControl.domainValidationOtp.invalid &&
                      (domainControl.domainValidationOtp.dirty ||
                        domainControl.domainValidationOtp.touched))
                  " class="error-msg">
                <div *ngIf="domainControl.domainValidationOtp.errors.required && !resendotp">
                  Please, enter OTP.
                </div>
                <div
                  *ngIf="domainControl.domainValidationOtp.errors.wrongDomainValidationOtp || !resendotp && !domainControl.domainValidationOtp.errors.required">
                  Incorrect OTP. Enter the right one.
                </div>
              </div>
            </div>






            <!-- <a style="margin-left:16px;" role="button" class="disabled" *ngIf="otpEmailSent && !resentOTPCode">Request another code in {{ " " }}</a>
            <span *ngIf="otpEmailSent && !resentOTPCode">
              <countdown style="margin-left: 10px;" [config]="{ leftTime: 120, format: 'mm:ss' }"></countdown>
            </span> -->
            <!-- <div class="row" *ngIf="resentOTPCode">
              <div class="pull-left" style="margin-left: 28px;" >
                <div>
                  <a role="button" *ngIf="!resendotp" (click)="requestAnotherOTP()">Request another code</a>
                </div>

                <p *ngIf="resendotp" style="color: #c3002f">
                  Another code has been sent to your business email address.
                  Please enter the code.
                </p>
              </div>
            </div> -->
            <div class="row" *ngIf="otpEmailSent">
              <div class="pull-left" style="margin-left: 28px;">
                <div>
                  <a role="button" *ngIf="!resendotp" (click)="requestAnotherOTP()">Request another code</a>
                </div>

                <div *ngIf="resendotp && !domainControl.domainValidationOtp.errors.wrongDomainValidationOtp "
                class="text-danger">
                  Another code has been sent to your business email address.
                  Please enter the code.
                </div>
              </div>
            </div>






          </div>
        </div>
      </form>
    </div>
    <div class="custom-panel-footer">
      <div class="panel-footer">
        <div class="shifu">
          <button class="btn  btn-primary" *ngIf="!otpEmailSent" type="button"
            (click)="proceedAfterValidation()">Proceed</button>
          <button *ngIf="!otpEmailSent" class="btn btn-default" (click)="closeValidator()">Go Back</button>

          <button class="btn  btn-primary" *ngIf="otpEmailSent" type="button" (click)="validateOtp()">Validate
            OTP</button>

        </div>
      </div>
    </div>

  </div>
</ng-template>

<ng-template #eduTemplate>


  <div class="common-header-flex">
    <div> Education </div>
    <button>
      <span class="common-close" (click)="decline()">&times;</span>
    </button>
  </div>

  <div class="panel-body edu-panel-body">
    <div class="row">
      <form [formGroup]="eduForm" class="app-form">
        <div formArrayName="educationDetail">
          <div *ngFor="let work of geteducation.controls; let i  = index; let lastItem = last;">
            <div [formGroupName]="i" class="form-horizontal">
              <div class="row">
                <div class="form-group">
                  <label for="schoolName" class="col-sm-4 control-label required-field font-light">School / College /
                    University</label>

                  <div class="col-sm-7">
                    <div class="row">
                      <div class="col-sm-12">
                        <input placeholder="School Name" maxlength="51" class="form-control input-sm max-hight"
                          formControlName="schoolName"
                         [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['schoolName'].hasError('required') }"
                          (typeaheadOnSelect)="onChangeSchool($event, i)"
                          (typeaheadNoResults)="changeTypeaheadNoResults(i, 'edu')" [typeahead]="instList"
                          [typeaheadMinLength]="1" typeaheadOptionField="institutionName"
                          [typeaheadItemTemplate]="customItemTemplate1" autocomplete="off"
                          [typeaheadOrderBy]="sortConfigEdu">

                        <ng-template #customItemTemplate1 let-model="item">
                          <span>
                            <strong style="font-size: 14px;">
                              {{model.institutionName}}
                            </strong>
                            <br>
                            <i>
                              <small>
                                <span *ngIf="model.street"> {{model.street }} </span>
                                <span *ngIf="model.city"> {{model.city}} </span>
                                <span *ngIf="model.state"> {{model.state}} </span>
                                {{model.country}}
                              </small>
                            </i>
                          </span>
                        </ng-template>

                        <div *ngIf="(eduSaveFlag || getEducationFormGroup(i).controls['schoolName'].dirty ||
             getEducationFormGroup(i).controls['schoolName'].touched) &&
             getEducationFormGroup(i).controls['schoolName'].invalid"
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['schoolName'].hasError('required')">
                            School is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['schoolName'].hasError('minword')" class="school-min-error">
                            {{FORMERROR.SCHOOL_NAME_MIN}}
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['schoolName'].hasError('maxword')">
                            {{FORMERROR.SCHOOL_NAME_MAX}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <div class="custom-checkbox" title="Check if this is your current education">
                          <label class="checkbox-label font-bold" style="text-align: center">Currently
                            Pursuing
                            <input type="checkbox" (change)="currentlyPursued($event, i)"
                              formControlName="currentlyPursued" name="currentlyPursued"
                              [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError }">
                            <span class="checkmark" title="Check this if you're currently studying here"></span>
                          </label>
                        </div>
                        <div class="text-dander" style="position: absolute;
                                                    right: 170px;
                                                    font-size: 12px;
                                                    font-weight: 500;"
                          *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['currentlyPursued'].hasError('validateEduIfChecked')">
                          Currently pursued is required</div>

                      </div>
                      <div class="col-sm-12">
                        <div class="custom-checkbox">
                          <label class="checkbox-label font-bold"> Show this education in
                            Profile
                            <input type="checkbox" formControlName="showThisOnProfile"
                              (change)="showThisEducation($event, i)" name="showThisOnProfile">
                            <span class="checkmark"
                              title="Only when this is checked, this workplace is shown in Profile"></span>
                          </label>

                          <div class="error-msg"
                            *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['showThisOnProfile'].hasError('checkEduShowIfChecked')">
                            Show at least one education</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">Location</label>

                  <div class="col-sm-7">
                    <div class="row form-group">
                      <div class="col-sm-6 ">
                        <select class="form-control input-sm" formControlName="country" type="text"
                          (change)="onChangeCountry($event.target.value,'edu',i)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['country'].errors }">
                          <option value="null" selected disabled>Country</option>
                          <option *ngFor="let country of countryList" [value]="country.countryCode">
                            {{country.countryName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['country'].hasError ||
                                                        getEducationFormGroup(i).controls['country'].hasError &&
                                                        (getEducationFormGroup(i).controls['country'].dirty ||
                                                        getEducationFormGroup(i).controls['country'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['country'].hasError('required')">
                            Country is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm" (keyup)="onKeyZip($event,'edu', i)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].errors }">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].hasError ||
                                                 getEducationFormGroup(i).controls['zipcode'].hasError &&
                                                 (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                                 getEducationFormGroup(i).controls['zipcode'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')">
                            Zip code is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>

                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='IN'">
                        <select class="form-control input-sm" formControlName="state" type="text">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListIN" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].invalid ||
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='CA'">
                        <select class="form-control input-sm" formControlName="state" type="text">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListCA" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].invalid ||
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='AU'">
                        <select class="form-control input-sm" formControlName="state" type="text">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListAU" [value]="state.stateName">{{state.stateName}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].invalid ||
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='AU'&&
                                                                            educationDetail.value[i].country!='CA'&&
                                                                            educationDetail.value[i].country!='IN'&&
                                                                            educationDetail.value[i].country!='US'">
                        <input formControlName="state" maxlength="51" class="form-control input-sm" placeholder="State">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].invalid ||
                                                 (getEducationFormGroup(i).controls['state'].dirty ||
                                                 getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input disabled type="text" maxlength="51" placeholder="City" formControlName="city"
                          class="form-control input-sm">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].invalid ||
                                                (getEducationFormGroup(i).controls['city'].dirty ||
                                                getEducationFormGroup(i).controls['city'].touched) " class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                            City is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('maxword')">
                            {{FORMERROR.CITY_MAX}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">
                        <input type="text" maxlength="51" placeholder="City" formControlName="city"
                          class="form-control input-sm">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['city'].invalid ||
                                                (getEducationFormGroup(i).controls['city'].dirty ||
                                                getEducationFormGroup(i).controls['city'].touched) " class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('required')">
                            City is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['city'].hasError('maxword')">
                            {{FORMERROR.CITY_MAX}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country=='US'">
                        <input disabled maxlength="51" formControlName="state" class="form-control input-sm"
                          placeholder="State">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['state'].invalid ||
                                                (getEducationFormGroup(i).controls['state'].dirty ||
                                                getEducationFormGroup(i).controls['state'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('required')">
                            State is required
                          </div>
                          <div *ngIf="getEducationFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}
                          </div>
                        </div>

                      </div>

                      <div class="col-sm-6" *ngIf="educationDetail.value[i].country!='US'">

                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm">
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['zipcode'].invalid ||
                                              (getEducationFormGroup(i).controls['zipcode'].dirty ||
                                              getEducationFormGroup(i).controls['zipcode'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('required')">
                            Zip code is required</div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('minword')">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getEducationFormGroup(i).controls['zipcode'].hasError('maxword')">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group">
                  <label for="degree" class="col-sm-4 control-label required-field font-light">Degree</label>

                  <div class="col-sm-7">
                    <input type="text" maxlength="51" class="form-control input-sm" placeholder="Degree"
                      formControlName="degree" trim="blur">
                    <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['degree'].invalid ||
                                       (getEducationFormGroup(i).controls['degree'].dirty ||
                                       getEducationFormGroup(i).controls['degree'].touched) " class="error-msg">
                      <div *ngIf="getEducationFormGroup(i).controls['degree'].hasError('required')">
                        Degree is required
                      </div>
                      <div *ngIf="getEducationFormGroup(i).controls['degree'].hasError('maxword')">
                        {{FORMERROR.DEGREE_MAX}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group">
                  <label for="speciality" class="col-sm-4 required-field control-label font-light">Speciality</label>
                  <div class="col-sm-7">
                    <input type="text" maxlength="51" class="form-control input-sm" placeholder="Speciality"
                      formControlName="speciality" trim="blur">
                    <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['speciality'].invalid ||
                                        (getEducationFormGroup(i).controls['speciality'].dirty ||
                                        getEducationFormGroup(i).controls['speciality'].touched) " class="error-msg">
                      <div *ngIf="getEducationFormGroup(i).controls['speciality'].hasError('required')">
                        Speciality is required
                      </div>
                      <div *ngIf="getEducationFormGroup(i).controls['speciality'].hasError('maxword')">
                        {{FORMERROR.SPECIALITY_MAX}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">From
                    Date</label>
                  <div class="col-sm-7">
                    <div class="row">
                      <div class="col-sm-6">
                        <select type="text" formControlName="startMonth" class="form-control input-sm"
                          (change)="monthChange(i,'edu')"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].errors }">

                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth1(month.code,i,'edu')">{{month.name}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startMonth'].invalid ||
                                        (getEducationFormGroup(i).controls['startMonth'].dirty ||
                                        getEducationFormGroup(i).controls['startMonth'].touched) " class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['startMonth'].hasError('required')">
                            From date is required
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <select type="text" formControlName="startYear" class="form-control input-sm"
                          (change)="yearChange(i,$event,'edu',null)">

                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years" [value]="year">{{year}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['startYear'].invalid ||
                                                  (getEducationFormGroup(i).controls['startYear'].dirty ||
                                                  getEducationFormGroup(i).controls['startYear'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['startYear'].hasError('required')">
                            Start Year is required
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="educationDetail.value[i].currentlyPursued==false">
                <div class="form-group">
                  <label class="control-label required-field col-sm-4 font-light">To Date</label>
                  <div class="col-sm-7">
                    <div class="row form-group">
                      <div class="col-sm-6">
                        <select type="text" formControlName="endMonth" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].errors }">
                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth(month.code,i,'edu')">{{month.name}}
                          </option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endMonth'].hasError ||
                                                getEducationFormGroup(i).controls['endMonth'].hasError &&
                                                (getEducationFormGroup(i).controls['endMonth'].dirty ||
                                                getEducationFormGroup(i).controls['endMonth'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['endMonth'].hasError('required')">
                            To date is required</div>
                        </div>

                      </div>
                      <div class="col-sm-6">
                        <select type="text" formControlName="endYear" class="form-control input-sm"
                          (change)="onChangeYear(i,'edu', null)"
                          [ngClass]="{ 'is-invalid': eduSaveFlag && getEducationFormGroup(i).controls['endYear'].errors }">

                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years" [value]="year" [disabled]="checkYear(year,i,'edu')">
                            {{year}}</option>
                        </select>
                        <div *ngIf="eduSaveFlag && getEducationFormGroup(i).controls['endYear'].hasError ||
                                                    getEducationFormGroup(i).controls['endYear'].hasError &&
                                                    (getEducationFormGroup(i).controls['endYear'].dirty ||
                                                    getEducationFormGroup(i).controls['endYear'].touched) "
                          class="error-msg">
                          <div *ngIf="getEducationFormGroup(i).controls['endYear'].hasError('required')">
                            End Year is required</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <hr *ngIf="!lastItem"> -->
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " *ngIf="eduEditFlag" type="button" (click)="eduSave('edit')"
          [disabled]="!eduForm.valid">
          Update
        </button>
        <button class="btn primary-btn " *ngIf="eduAddFlag" type="button" (click)="eduSave('add')">
          Submit
        </button>
      </div>
    </div>
  </div>


</ng-template>

<ng-template #physicianPrompTemplate>
  <div class="modal-dialog ">
    <div class="modal-content">
      <div style="justify-content: center; display: flex; padding: 10px;">
        <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
      </div>
      <div class="text-center"><label>Are you sure?</label></div>
      <div class="modal-body" style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
        <p>Changing to {{"'" + userTypeValue + "'"}} user type requires your work experience. If you had not
          provided your
          work experience details, on submitting the
          form you will be asked to fill your work experience. Do you wish to continue?
        </p><br>
      </div>
      <div class="row" style="padding: 10px;">
        <div class="col-sm-6">
          <button (click)="hidePhyPrompt()" class="btn btn-default btn-block">Cancel</button>
        </div>
        <div class="col-sm-6">
          <button (click)="changeToPhysician()" class="btn primary-btn btn-block">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #studentPrompTemplate>
  <div class="modal-dialog">
    <div class="modal-content">
      <div style="justify-content: center; display: flex; padding: 10px;">
        <img style="height: 80px; width: 80px;" src="assets/icon/warning.png">
      </div>
      <div class="text-center"><label>Are you sure?</label></div>
      <div class="modal-body" style="padding: 0px 0px 0px 22px; justify-content: center; display: flex">
        <p>Changing to Student (Medical/ Healthcare) user type requires your education
          qualifications. If you
          hadnt provided your education details already, on submitting the
          form you will be asked to fill your education details. Do you wish to continue?
        </p><br>
      </div>
      <div class="row" style="padding: 10px;">
        <div class="col-sm-6">
          <button (click)="hideStudPrompt()" class="btn btn-default btn-block">Cancel</button>
        </div>
        <div class="col-sm-6">
          <button (click)="changeToStudent()" class="btn primary-btn btn-block">Continue</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<div *ngIf="workModalShown" class="modal-md modal fade" [config]='promptConfig' (onHidden)="onHideWrkMandTemp()" bsModal
  #autoShownModal tabindex="-1" role="dialog" aria-labelledby="dialog-auto-name">

  <div class="modal-dialog">
    <div class="modal-content" [ngClass]="{ 'scrollModal': showOtherPrompt}">
      <label class="control-label" style="margin: 15px 0px 9px 15px;">Work Experiencde</label>
      <hr style="border: 0; border-top: 2px solid #eee; margin-top:0px; margin-bottom:0px">

      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12 cp margin-top-12">
            <div class="row">
              <div class="col-sm-2 promp-align1" *ngIf="showOtherPrompt==false">
                Note:
              </div>
              <div *ngIf="showOtherPrompt==false" class="col-sm-10 promp-align1"
                style="padding-left: 0px;margin-left: -39px;">
                <p>
                  For usertype other than Student (Medical/ Healthcare) work experience is
                  mandatory Please provide your
                  work experience details below. Or click Cancel and return back to your previous
                  user type
                </p>
              </div>

              <div *ngIf="showOtherPrompt==true" class="col-sm-10 promp-align1" style="float: right">
                <p> Please check if you want to change any details of the work experience you have provided. </p>
              </div>
            </div>
          </div>
        </div>

        <form [formGroup]="eperienceForm" class="app-form">
          <div formArrayName="workExperience">
            <div *ngFor="let work of experienceArray.controls; let i = index; let lastItem = last">
              <div [formGroupName]="i">
                <div class="row form-group">
                  <label for="organisationName"
                    class="col-sm-2 control-label required-field text-right font-light">Organization</label>
                  <div class="col-sm-9">

                    <input placeholder="Organization" class="form-control input-sm max-hight"
                      formControlName="organisationName"
                      [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['organisationName'].hasError }"
                      (typeaheadOnSelect)="onChngOrg($event, 0)"
                      (typeaheadNoResults)="changeTypeaheadNoResults(i, 'work')" [typeahead]="uniqueOrgList"
                      [typeaheadMinLength]="0" typeaheadOptionField="organizationName"
                      [typeaheadItemTemplate]="customItemTemplate2" autocomplete="off"
                      [typeaheadOrderBy]="sortConfigWork">

                    <ng-template #customItemTemplate2 let-model="item">
                      <span>
                        <strong style="font-size: 14px;">
                          {{model.organizationName}}
                        </strong>
                        <br>
                        <i>
                          <small>
                            {{model.street }}<span *ngIf="model.street">{{", "}}</span>
                            {{model.city}}<span *ngIf="model.city">{{", "}}</span>
                            {{model.state}}<span *ngIf="model.state">{{", "}}</span>
                            {{model.countryName}}
                          </small>
                        </i>
                      </span>
                    </ng-template>
                    <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['organisationName'].hasError"
                      class="error-msg">
                      <div *ngIf="getWorkFormGroup(i).controls['organisationName'].hasError('required')">
                        Organization is required</div>
                      <div *ngIf="getWorkFormGroup(i).controls['organisationName'].hasError('pattern')">
                        Please avoid unwanted spaces</div>
                    </div>

                    <div class="row">
                      <div class="col-sm-12">
                        <div class="custom-checkbox" title="Check if this is your current workplace">
                          <label class="checkbox-label font-bold" style="text-align: center">Current
                            Organization
                            <input type="checkbox" (change)="curOrg($event, i)" formControlName="currentOrganization"
                              name="currentOrganization"
                              [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['currentOrganization'].hasError }">
                            <span class="checkmark"></span>
                          </label>
                        </div>
                        <div class="error-msg"
                          *ngIf="getWorkFormGroup(i).controls['currentOrganization'].hasError('validateIfChecked')">
                          Current Organization is required</div>

                      </div>
                      <div class="col-sm-12">
                        <div class="custom-checkbox"
                          *ngIf="workExperience.value[i].currentOrganization===true && (commonVariables?.currentIndex === i || commonVariables?.currentIndex === null)">
                          <label class="checkbox-label font-bold"> Show this workplace in
                            Profile
                            <input type="checkbox" formControlName="badge" (change)="showThis($event, i)" name="badge">
                            <span class="checkmark"
                              title="Only when this is checked, this workplace is shown in Profile"></span>
                          </label>

                          <div class="error-msg"
                            *ngIf="getWorkFormGroup(i).controls['badge'].hasError('checkIfChecked')">
                            Show at least one organization</div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="col-sm-1" *ngIf="showOtherPrompt==true && commonVariables?.localUser">
                    <div style="margin-left: -13px;" title="Remove work experience"
                      (click)="removeWorkIndex(work.value,i)">
                      <button class="gs-icon-btn"><span>
                          <ng-icon name="tablerTrash" class="gs-icon-action"></ng-icon>
                        </span></button>
                    </div>
                  </div>

                </div>

                <div class="row form-group">
                  <label for="title" class="col-sm-2 control-label required-field text-right font-light">Title</label>
                  <div class="col-sm-9">
                    <input type="text" *ngIf="!physicianFlag && !adminFlag && !commonVariables?.studentFlag"
                      class="form-control input-sm" placeholder="Title" formControlName="title"
                      [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['title'].hasError }">
                    <div >
                      <ng-select *ngIf="physicianFlag" [items]="phyTitleList" [addTag]="false" [hideSelected]="true"
                        dropdownPosition="bottom" formControlName="title" [multiple]="false" placeholder="Title">
                      </ng-select>
                    </div>
                    <div >
                      <ng-select *ngIf="adminFlag" [items]="busiTitleList" [addTag]="false" [hideSelected]="true"
                        dropdownPosition="bottom" formControlName="title" [multiple]="false" placeholder="Title">
                      </ng-select>
                    </div>
                    <div >
                      <ng-select *ngIf="commonVariables?.studentFlag" [items]="studentTitles" [addTag]="false"
                        [hideSelected]="true" dropdownPosition="bottom" formControlName="title" [multiple]="false"
                        placeholder="Title">
                      </ng-select>
                    </div>

                    <!-- <input *ngIf="physicianFlag" [typeaheadMinLength]="0" [typeahead]="phyTitleList"
                                            placeholder="Title"class="form-control input-sm"  formControlName="title"
                                            [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['title'].hasError }">

                                            <input *ngIf="adminFlag" [typeaheadMinLength]="0" [typeahead]="busiTitleList"
                                                placeholder="Title" class="form-control input-sm"  formControlName="title"
                                            [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['title'].hasError }"> -->

                    <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['title'].hasError" class="error-msg">
                      <div *ngIf="getWorkFormGroup(i).controls['title'].hasError('required')">
                        Title is required</div>
                    </div>
                  </div>

                </div>

                <div class="row form-group">
                  <label class="control-label col-sm-2 required-field text-right font-light">Location</label>
                  <!-- <label *ngIf="commonVariables?.studentFlag"
                                        class="control-label col-sm-2 text-right font-light">Location</label> -->
                  <div class="col-sm-9">
                    <div class="row form-group">
                      <div class="col-sm-6">
                        <select class="form-control input-sm" formControlName="country" type="text"
                          (change)="onChangeCountry($event.target.value,'work',i)"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['country'].hasError }">
                          <option value="null" selected disabled>Country</option>
                          <option *ngFor="let country of countryList" [value]="country.countryCode">
                            {{country.countryName}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['country'].hasError ||
                                            getWorkFormGroup(i).controls['country'].hasError &&
                                            (getWorkFormGroup(i).controls['country'].dirty ||
                                            getWorkFormGroup(i).controls['country'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['country'].hasError('required')">
                            Country is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='US'">
                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm" (keyup)="onKeyZip($event,'work', i)"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['zipcode'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['zipcode'].hasError ||
                                                getWorkFormGroup(i).controls['zipcode'].hasError &&
                                                (getWorkFormGroup(i).controls['zipcode'].dirty ||
                                                getWorkFormGroup(i).controls['zipcode'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('required')">
                            Zipcode is required</div>
                          <div *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('minword')">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('maxword')">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='CA'">
                        <select class="form-control input-sm" formControlName="state" id="ca" type="text"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListCA" [value]="state.stateName">
                            {{state.stateName}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['state'].hasError ||
                                                (getWorkFormGroup(i).controls['state'].hasError &&
                                                (getWorkFormGroup(i).controls['state'].dirty ||
                                                getWorkFormGroup(i).controls['state'].touched)) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='IN'">
                        <select class="form-control input-sm" formControlName="state" id="in" type="text"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListIN" [value]="state.stateName">
                            {{state.stateName}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['state'].hasError ||
                                                (getWorkFormGroup(i).controls['state'].hasError &&
                                                (getWorkFormGroup(i).controls['state'].dirty ||
                                                getWorkFormGroup(i).controls['state'].touched)) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='AU'">
                        <select class="form-control input-sm" formControlName="state" id="au" type="text"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['state'].hasError }">
                          <option value="null" selected disabled>State</option>
                          <option *ngFor="let state of stateListAU" [value]="state.stateName">
                            {{state.stateName}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['state'].hasError ||
                                            (getWorkFormGroup(i).controls['state'].hasError &&
                                            (getWorkFormGroup(i).controls['state'].dirty ||
                                            getWorkFormGroup(i).controls['state'].touched)) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="workExperience.value[i].country!='AU'&&
                                            workExperience.value[i].country!='IN'&&
                                            workExperience.value[i].country!='CA'&&
                                            workExperience.value[i].country!='US'">
                        <input type="text" placeholder="State" maxlength="51" formControlName="state" id="other"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['state'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['state'].hasError||
                                        getWorkFormGroup(i).controls['state'].hasError &&(getWorkFormGroup(i).controls['state'].dirty ||
                                        getWorkFormGroup(i).controls['state'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}</div>
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='US'">
                        <input disabled type="text" placeholder="City" formControlName="city"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['city'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['city'].hasError ||
                                    getWorkFormGroup(i).controls['city'].hasError &&
                                    (getWorkFormGroup(i).controls['city'].dirty ||
                                    getWorkFormGroup(i).controls['city'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['city'].hasError('required')">
                            City is required</div>
                        </div>
                      </div>

                      <div class="col-sm-6" *ngIf="workExperience.value[i].country!='US'">
                        <input type="text" placeholder="City" formControlName="city" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['city'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['city'].hasError ||
                                    getWorkFormGroup(i).controls['city'].hasError &&
                                    (getWorkFormGroup(i).controls['city'].dirty ||
                                    getWorkFormGroup(i).controls['city'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['city'].hasError('required')">
                            City is required</div>
                        </div>
                      </div>


                      <div class="col-sm-6" *ngIf="workExperience.value[i].country!='US'">
                        <input type="text" maxlength="12" placeholder="Zipcode" formControlName="zipcode"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['zipcode'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['zipcode'].hasError ||
                                    getWorkFormGroup(i).controls['zipcode'].hasError &&
                                    (getWorkFormGroup(i).controls['zipcode'].dirty ||
                                    getWorkFormGroup(i).controls['zipcode'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('required')">
                            Zipcode is required</div>
                          <div *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('minword')">
                            {{FORMERROR.ZIPCODE_MIN}}
                          </div>
                          <div class="w-wrap" *ngIf="getWorkFormGroup(i).controls['zipcode'].hasError('maxword')">
                            {{FORMERROR.ZIPCODE_MAX}}
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6" *ngIf="workExperience.value[i].country=='US'">
                        <input disabled type="text" placeholder="State" formControlName="state" maxlength="51"
                          class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['state'].hasError }">
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['state'].hasError ||
                                    getWorkFormGroup(i).controls['state'].hasError &&
                                    (getWorkFormGroup(i).controls['state'].dirty ||
                                    getWorkFormGroup(i).controls['state'].touched) " class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('required')">
                            State is required</div>
                          <div *ngIf="getWorkFormGroup(i).controls['state'].hasError('maxword')">
                            {{FORMERROR.STATE_MAX}}</div>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="row">
                                            <div class="col-sm-12">
                                                <input type="text" placeholder="Street/ Road /Nearby Landmark"
                                                    formControlName="street" class="form-control input-sm"
                                                    [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['street'].hasError }">
                                                <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['street'].hasError ||
                                    getWorkFormGroup(i).controls['street'].hasError &&
                                    (getWorkFormGroup(i).controls['street'].dirty ||
                                    getWorkFormGroup(i).controls['street'].touched) " class="error-msg">
                                                    <div
                                                        *ngIf="getWorkFormGroup(i).controls['street'].hasError('required')">
                                                        Street name is required</div>
                                                </div>
                                            </div>

                                        </div> -->
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-2 control-label  required-field text-right font-light">From
                    Date</label>
                  <div class="col-sm-9">
                    <div class="row">
                      <div class="col-sm-6">
                        <select type="text" formControlName="startMonth" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['startMonth'].hasError }"
                          (change)="monthChange(i,'exp')">

                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth1(month.code,i,'exp')">{{month.name}}
                          </option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['startMonth'].hasError"
                          class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['startMonth'].hasError('required')">
                            From date is required</div>
                        </div>
                      </div>

                      <div class="col-sm-6">
                        <select type="text" formControlName="startYear" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['startYear'].hasError }"
                          (change)="yearChange(i,$event,'exp','stYr')">
                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years" [value]="year">{{year}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['startYear'].hasError"
                          class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['startYear'].hasError('required')">
                            Start Year is required</div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="form-group row" *ngIf="workExperience.value[i].currentOrganization==false">
                  <!-- <label *ngIf="commonVariables?.studentFlag" class="col-sm-2 control-label  text-right font-light">To
                                        Date </label> -->
                  <label class="col-sm-2 control-label  required-field text-right font-light">To Date
                  </label>
                  <div class="col-sm-9">
                    <div class="row">
                      <div class="col-sm-6">
                        <select type="text" formControlName="endMonth" class="form-control input-sm"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['endMonth'].hasError }">

                          <option value="null" selected disabled>Month</option>
                          <option *ngFor="let month of months" [value]="month.name"
                            [disabled]="checkMonth(month.code,i,'exp')">{{month.name}}
                          </option>

                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['endMonth'].hasError"
                          class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['endMonth'].hasError('required')">
                            To date is required</div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <select placeholder="Year" type="text" formControlName="endYear" class="form-control input-sm"
                          (change)="onChangeYear(i,'exp','endYr')"
                          [ngClass]="{ 'is-invalid': workSaveFlag && getWorkFormGroup(i).controls['endYear'].hasError }">

                          <option value="null" disabled>Year</option>
                          <option *ngFor="let year of years" [value]="year" [disabled]="checkYear(year,i,'exp')">
                            {{year}}</option>
                        </select>
                        <div *ngIf="workSaveFlag && getWorkFormGroup(i).controls['endYear'].hasError" class="error-msg">
                          <div *ngIf="getWorkFormGroup(i).controls['endYear'].hasError('required')">
                            End Year is required</div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>


              </div>
              <hr *ngIf="!lastItem">
            </div>

          </div>
          <div class="text-right" style="margin-right: 49px;">
            <button class="btn btn-default " *ngIf="indexZero || indexOne"
              (click)="infoEdit(infoTemplate, 'previous')">
              Cancel
            </button>
            <button *ngIf="indexZero" style="margin-left: 5px" class="btn primary-btn "
              (click)="experSave('newOrg')" [disabled]="!eperienceForm.valid">
              Add Work Experience
            </button>
            <button *ngIf="indexOne" style="margin-left: 5px" class="btn primary-btn "
              (click)="experSave('updateOrg')" [disabled]="!eperienceForm.valid">
              Add Work Experience
            </button>
          </div>

          <div class="row text-right" style="margin-right: 49px;" *ngIf="showOtherPrompt">
            <button *ngIf="!showOtherPrompt" class="btn btn-default "
              (click)="infoEdit(infoTemplate, 'previous')">
              Cancel
            </button>
            <button class="btn secondary-btn " style="margin-left: 5px;" (click)="onHideWrkMandTemp()">
              Close
            </button>
            <button style="margin-left: 7px;" class="btn primary-btn " style="margin-left: 5px;"
              (click)="otherExperSave()">
              Update Work Experience
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>



<ng-template #certTemplate>

  <div class="common-header-flex">
    <div>Certifications</div>
    <button>
      <span class="common-close" (click)="modalRef.hide()">&times;</span>
    </button>
  </div>

  <div class="panel-body cert-panel-body">
    <div class="row">
      <form [formGroup]="certForm" class="app-form">
        <div class="row" formArrayName="certification">
          <div *ngFor="let work of getCertification.controls; let i  = index; let lastItem = last;">
            <div [formGroupName]="i" class="form-horizontal">
              <div class="form-group">
                <label for="certificationName" class="col-sm-4 control-label font-light required-field">Certificate
                  Name</label>
                <div class="col-sm-7">
                  <input placeholder="Certificate Name" maxlength="51" class="form-control input-sm max-hight"
                    formControlName="certificationName"
                    (typeaheadOnSelect)="onChangeCertificate($event, i)" [typeahead]="certificationList"
                    (typeaheadNoResults)="changeTypeaheadNoResults(i, 'cert')" [typeaheadMinLength]="1"
                    typeaheadOptionField="certificationName" [typeaheadItemTemplate]="customItemTemplate3"
                    autocomplete="off" [typeaheadOrderBy]="sortConfigCert">
                  <ng-template #customItemTemplate3 let-model="item">
                    {{model.certificationName}}
                  </ng-template>
                  <div *ngIf="certificationEdit && getCertFormGroup(i).controls['certificationName'].hasError ||
                                                getCertFormGroup(i).controls['certificationName'].hasError &&
                                                (getCertFormGroup(i).controls['certificationName'].dirty ||
                                                getCertFormGroup(i).controls['certificationName'].touched) "
                    class="error-msg">
                    <div *ngIf="getCertFormGroup(i).controls['certificationName'].hasError('required')">
                      Certification Name is required
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificationName'].hasError('minword')">
                      {{FORMERROR.CERTIFICATION_NAME_MIN}}
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificationName'].hasError('maxword')">
                      {{FORMERROR.CERTIFICATION_NAME_MAX}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="certificateOrganization" class="col-sm-4 control-label font-light required-field">Certifying
                  Organization</label>
                <div class="col-sm-7">
                  <input type="text" class="form-control input-sm" maxlength="51" placeholder="Certifying Organization"
                    formControlName="certificateOrganization">

                  <div *ngIf="certificationEdit && getCertFormGroup(i).controls['certificateOrganization'].hasError ||
                                                getCertFormGroup(i).controls['certificateOrganization'].hasError &&
                                                (getCertFormGroup(i).controls['certificateOrganization'].dirty ||
                                                getCertFormGroup(i).controls['certificateOrganization'].touched) "
                    class="error-msg">
                    <div *ngIf="getCertFormGroup(i).controls['certificateOrganization'].hasError('required')">
                      Certifying Organization is required
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificateOrganization'].hasError('minword')">
                      {{FORMERROR.CERTIFICATION_ORG_MIN}}
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificateOrganization'].hasError('maxword')">
                      {{FORMERROR.CERTIFICATION_ORG_MAX}}
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="certificateLicenseNo" class="col-sm-4 control-label font-light required-field">License
                  Number</label>
                <div class="col-sm-7">
                  <input type="text" class="form-control input-sm" maxlength="51" placeholder="License Number"
                    formControlName="certificateLicenseNo">


                  <div *ngIf="certificationEdit && getCertFormGroup(i).controls['certificateLicenseNo'].hasError ||
                                                getCertFormGroup(i).controls['certificateLicenseNo'].hasError &&
                                                (getCertFormGroup(i).controls['certificateLicenseNo'].dirty ||
                                                getCertFormGroup(i).controls['certificateLicenseNo'].touched) "
                    class="error-msg">
                    <div *ngIf="getCertFormGroup(i).controls['certificateLicenseNo'].hasError('required')">
                      License Number is required
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificateLicenseNo'].hasError('minword')">
                      {{FORMERROR.CERTIFICATION_LICENSE_MIN}}
                    </div>
                    <div *ngIf="getCertFormGroup(i).controls['certificateLicenseNo'].hasError('maxword')">
                      {{FORMERROR.CERTIFICATION_LICENSE_MAX}}
                    </div>
                  </div>
                </div>
              </div>


              <div class="form-group row">
                <label class="col-sm-4 control-label font-light required-field">Issue Date</label>
                <div class="col-sm-7">
                  <div class="row">
                    <div class="col-sm-6">
                      <select type="text" formControlName="startMonth" class="form-control input-sm"
                        (change)="monthChange(i,'cert'); onChangeIssueMonth(i)">

                        <option value="null" selected disabled>Month</option>
                        <option *ngFor="let month of months" [value]="month.name"
                          [disabled]="checkMonth1(month.code,i,'cert')">{{month.name}}
                        </option>
                      </select>
                      <div *ngIf="certificationEdit && getCertFormGroup(i).controls['startMonth'].hasError ||
                                                            getCertFormGroup(i).controls['startMonth'].hasError &&
                                                            (getCertFormGroup(i).controls['startMonth'].dirty ||
                                                            getCertFormGroup(i).controls['startMonth'].touched) "
                        class="error-msg">
                        <div *ngIf="getCertFormGroup(i).controls['startMonth'].hasError('required')">
                          Issue month is required
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <select type="text" formControlName="startYear" class="form-control input-sm"
                        (change)="yearChange(i,$event,'cert', null); onChangeIssueYear(i)">
                        <option *ngFor="let year of years" [value]="year">{{year}}
                        </option>
                      </select>
                      <div *ngIf="certificationEdit && getCertFormGroup(i).controls['startYear'].hasError ||
                                                    getCertFormGroup(i).controls['startYear'].hasError &&
                                                    (getCertFormGroup(i).controls['startYear'].dirty ||
                                                    getCertFormGroup(i).controls['startYear'].touched) "
                        class="error-msg">
                        <div *ngIf="getCertFormGroup(i).controls['startYear'].hasError('required')">
                          Issue year is required
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-4 control-label  font-light required-field">Expiration
                  Date</label>
                <div class="col-sm-7">
                  <div class="row">
                    <div class="col-sm-6">
                      <select type="text" formControlName="endMonth" class="form-control input-sm">
                        <option value="null" selected disabled>Month</option>
                        <option *ngFor="let month of months" [value]="month.name"
                          [disabled]="checkExpirationMonth(month.code, i)">{{month.name}}
                        </option>
                      </select>
                      <div *ngIf="certificationEdit && getCertFormGroup(i).controls['endMonth'].hasError ||
                                                    getCertFormGroup(i).controls['endMonth'].hasError &&
                                                    (getCertFormGroup(i).controls['endMonth'].dirty ||
                                                    getCertFormGroup(i).controls['endMonth'].touched) "
                        class="error-msg">
                        <div *ngIf="getCertFormGroup(i).controls['endMonth'].hasError('required')">
                          Expiration month is required
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <select type="text" formControlName="endYear" class="form-control input-sm"
                        (change)="onChangeExpirationYear(i)">
                        <option *ngFor="let year of certExpirationYears" [value]="year" [disabled]="checkExpirationYear(year, i)">
                          {{year}}</option>
                      </select>
                      <div *ngIf="certificationEdit && getCertFormGroup(i).controls['endYear'].hasError ||
                                                    getCertFormGroup(i).controls['endYear'].hasError &&
                                                    (getCertFormGroup(i).controls['endYear'].dirty ||
                                                    getCertFormGroup(i).controls['endYear'].touched) "
                        class="error-msg">
                        <div *ngIf="getCertFormGroup(i).controls['endYear'].hasError('required')">
                          Expiration year is required
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " *ngIf="certEditFlag" type="button" (click)="certSave('edit')"
          [disabled]="!certForm.valid">
          Submit
        </button>
        <button class="btn primary-btn " *ngIf="certAddFlag" type="button" (click)="certSave('add')"
          [disabled]="!certForm.valid">
          Submit
        </button>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #socialPresenceTemplate>

  <div class="common-header-flex">
    <div>Social Influence</div>
    <button>
      <span (click)="modalRef.hide()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="panel-body">
    <form [formGroup]="socialPresenceForm" class="app-form">
      <div class="row form-horizontal">
        <div class="form-group">
          <label for="linkedin" class="col-sm-3 control-label font-light ">LinkedIn</label>
          <div class="col-sm-8">
            <input type="text" class="form-control input-sm" placeholder="Linkedin" trim="blur"
              formControlName="linkedin">
            <div class="error-msg" *ngIf="  SocialControls.linkedin.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="certificationName" class="col-sm-3 control-label font-light">X</label>
          <div class="col-sm-8">
            <input type="text" class="form-control input-sm" placeholder="X" trim="blur"
              formControlName="twitter">
            <div class="error-msg" *ngIf=" SocialControls.twitter.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="facebook" class="col-sm-3 control-label font-light">Facebook</label>
          <div class="col-sm-8">
            <input type="text" class="form-control input-sm" placeholder="Facebook" trim="blur"
              formControlName="facebook">
            <div class="error-msg" *ngIf="  SocialControls.facebook.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="blogURL" class="col-sm-3 control-label font-light">Blog</label>
          <div class="col-sm-8">
            <input type="text" class="form-control input-sm" placeholder="Blog" trim="blur" formControlName="blogURL">
            <div class="error-msg" *ngIf="  SocialControls.blogURL.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="alternamePageLink" class="col-sm-3 control-label font-light">Personal
            Website</label>
          <div class="col-sm-8">
            <input type="text" class="form-control input-sm" placeholder="Personal Website" trim="blur"
              formControlName="alternamePageLink">
            <div class="error-msg" *ngIf=" SocialControls.alternamePageLink.errors?.pattern">
              {{FORMERROR.HTTP_VALID}}
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <div class="custom-panel-footer">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default " (click)="decline()">
          Cancel
        </button>
        <button class="btn primary-btn " type="button" [disabled]="!socialPresenceForm.valid"
          (click)="socialPresenceSave()">
          Submit
        </button>
      </div>
    </div>
  </div>

</ng-template>


<app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage()" style="z-index: -1;"
  [messageDataPass]="messageData"> </app-message-widget>
